import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./PrivacyNoticeView.styles";
import { useTranslation } from "react-i18next";

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    WithStyles,
    withStyles,
} from "@material-ui/core";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IPrivacyViewProps extends WithStyles<typeof styles> {}

const PrivacyNoticeViewPure: React.FunctionComponent<IPrivacyViewProps> = ({ classes }) => {
    const {t} = useTranslation();
    return <CenteredContainer>
        <div className={classes.title}>
            <Typography variant="h2" gutterBottom>{t("footer.privacy.title")}</Typography>
            <Typography variant="body1">{t("footer.privacy.introduction1")}</Typography>
            <Typography variant="body1">{t("footer.privacy.introduction2")}</Typography>
            <Typography variant="h3">{t("footer.privacy.controller")}</Typography>
            <Typography variant="h4">{t("footer.privacy.identityTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.identityText")}</Typography>
            <Typography variant="body1">Deutsche Börse AG<br></br>60485 Frankfurt am Main<br></br>{t("general.germany")}</Typography>
            <Typography variant="body1">{t("general.phone")}: +49-(0) 69-2 11-0<br></br>{t("general.email")}: <a href="mailto:info@deutsche-boerse.com" target="_self">info@deutsche-boerse.com</a></Typography>
            <Typography variant="h4">{t("footer.privacy.contactTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.contactText")}<br></br>Data Protection Officer Deutsche Börse AG<br></br>Deutsche Börse AG<br></br>60485 Frankfurt am Main<br></br><a href="mailto:dataprotection@deutsche-boerse.com" target="_self">dataprotection@deutsche-boerse.com</a></Typography>

            <Typography variant="h3">{t("footer.privacy.purpose")}</Typography>
            <Typography variant="h4">{t("footer.privacy.categoriesTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.categoriesText1")}</Typography>
            <Typography variant="body1">{t("footer.privacy.categoriesText2")}</Typography>
            <Typography variant="body1">{t("footer.privacy.categoriesText3")}</Typography>
            <Typography variant="body1">{t("footer.privacy.categoriesText4")}</Typography>
            <Typography variant="body1">{t("footer.privacy.categoriesText5")}</Typography>

            <Typography variant="h4">{t("footer.privacy.personalTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.personalText")}</Typography>
            <Typography variant="body1">{t("footer.privacy.consequences")}</Typography>

            <Typography variant="h4">{t("footer.privacy.automatedTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.automatedText")}</Typography>

            <Typography variant="h3">{t("footer.privacy.transferTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.transferText1")}</Typography>
            <Typography variant="body1">{t("footer.privacy.transferText2")}</Typography>
            <Typography variant="body1">{t("footer.privacy.transferText3")}</Typography>

            <Typography variant="h3">{t("footer.privacy.cookiesTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesText1")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesText2")}</Typography>
            <Typography variant="body1">{t("footer.privacy.localStorage1")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesText3")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesText4")}</Typography>

            <Typography variant="h4">{t("footer.privacy.cookiesTypesTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText1")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText2")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText3")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText4")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText5")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText6")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText7")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText8")}</Typography>
            <Typography variant="body1">{t("footer.privacy.cookiesTypesText9")}</Typography>

            <Typography variant="h4">{t("footer.privacy.ourCookies")}</Typography>
            <Typography variant="body1">{t("footer.privacy.necessaryLocalStorage")}</Typography>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell><strong>Local Storage - Name</strong></TableCell>
                        <TableCell><strong>{t("general.description")}</strong></TableCell>
                        <TableCell><strong>Retention period</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>cookie_consent</TableCell>
                        <TableCell>User has confirmed cookies</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>refresh_token</TableCell>
                        <TableCell>Application token to request data from the Datashop</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>i18nextLng</TableCell>
                        <TableCell>Preferred language</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>logoutReason</TableCell>
                        <TableCell>Logout reason of the last session</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>basket-checkout</TableCell>
                        <TableCell>Termporary basket content</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>id_token</TableCell>
                        <TableCell>Application token to request data from the Datashop</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>access_token</TableCell>
                        <TableCell>Application token to request data from the Datashop</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>LOG_IN_PATHNAME</TableCell>
                        <TableCell>Redirection path after login</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <Typography variant="body1">{t("footer.privacy.functionalLocalStorage")}</Typography>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell><strong>Functional Storage - Name</strong></TableCell>
                        <TableCell><strong>{t("general.description")}</strong></TableCell>
                        <TableCell><strong>Retention period</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>yt-player-bandwidth</TableCell>
                        <TableCell>Playing of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>yt-player-headers-readable</TableCell>
                        <TableCell>Playing of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>yt-remote-connected-devices</TableCell>
                        <TableCell>Availability of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>yt-remote-device-id</TableCell>
                        <TableCell>Availability of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>yt.innertube::nextId</TableCell>
                        <TableCell>Availability of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>yt.innertube::requests</TableCell>
                        <TableCell>Availability of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>ytidb::LAST_RESULT_ENTRY_KEY</TableCell>
                        <TableCell>Availability of the embedded video</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <Typography variant="body1">{t("footer.privacy.necessaryCookies")}</Typography>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell><strong>Necessary Cookies - Name</strong></TableCell>
                        <TableCell><strong>{t("general.description")}</strong></TableCell>
                        <TableCell><strong>Domain</strong></TableCell>
                        <TableCell><strong>Retention period</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>hjSessionUser</TableCell>
                        <TableCell>Ensure the further transfer to the payment provider’s website for the user to submit and confirm the payment</TableCell>
                        <TableCell>.unzer.com</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>AWSALBCORS</TableCell>
                        <TableCell>Ensure the further transfer to the payment provider’s website for the user to submit and confirm the payment</TableCell>
                        <TableCell>payment.heidelpay.com</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>AWSALB</TableCell>
                        <TableCell>Ensure the further transfer to the payment provider’s website for the user to submit and confirm the payment</TableCell>
                        <TableCell>payment.heidelpay.com</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <Typography variant="body1">{t("footer.privacy.functionalCookies")}</Typography>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell><strong>Functional Cookies - Name</strong></TableCell>
                        <TableCell><strong>{t("general.description")}</strong></TableCell>
                        <TableCell><strong>Domain</strong></TableCell>
                        <TableCell><strong>Retention period</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>YouTube-nocookie</TableCell>
                        <TableCell>Allowing the integration of videos from YouTube for each embedded video</TableCell>
                        <TableCell>Google LLC (.youtube.com)</TableCell>
                        <TableCell>{t("footer.privacy.retentionMonths")}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <Typography variant="h4">{t("footer.privacy.manageCookiesTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.manageCookiesText")}</Typography>
            <Typography variant="body1">{t("footer.privacy.manageCookiesNote")}</Typography>

            <Typography variant="h4">{t("footer.privacy.deactivateCookiesTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.deactivateCookiesText")}</Typography>
            <Typography variant="body1">Mozilla Firefox (<a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored</a>)</Typography>
            <Typography variant="body1">Internet Explorer (<a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies</a>)</Typography>
            <Typography variant="body1">Google Chrome (<a href="https://support.google.com/accounts/answer/61416?hl=en">https://support.google.com/accounts/answer/61416?hl=en</a>)</Typography>
            <Typography variant="body1">Safari (<a href="https://support.apple.com/en-en/guide/safari/sfri11471/mac">https://support.apple.com/en-en/guide/safari/sfri11471/mac</a>)</Typography>

            <Typography variant="h3">{t("footer.privacy.yourRightsTitle")}</Typography>
            <Typography variant="body1">{t("footer.privacy.yourRightsText1")}</Typography>
            <Typography variant="body1"><ul><li>{t("footer.privacy.right1")}</li><li>{t("footer.privacy.right2")}</li><li>{t("footer.privacy.right3")}</li><li>{t("footer.privacy.right4")}</li></ul></Typography>
            <Typography variant="body1">{t("footer.privacy.yourRightsText2")}</Typography>
            <Typography variant="body1">{t("footer.privacy.yourRightsText3")}</Typography>
            <Typography variant="body1">{t("footer.privacy.listOfContacts")} <a href="https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080">{t("footer.privacy.here")}</a>.</Typography>

        </div>
    </CenteredContainer>;

};

export const PrivacyNoticeView = withStyles(styles)(PrivacyNoticeViewPure);
